import { get, pick } from 'lodash';
const EMPTY_SUB_PO_ITEM = [
  {
    poNo: null,
    orderQty: null,
    cartonsNo: null,
    clientName: null,
    clientPONo: null
  }
];

export const updateFieldValue = (
  existedValue,
  newSelectedProducts,
  defaultAQL
) => {
  return [
    ...existedValue,
    ...newSelectedProducts.map((selected) => {
      return {
        ...pick(selected, [
          'id',
          'name',
          'image',
          'itemNo',
          'supplierName',
          'factoryName',
          'isSignSample'
        ]),
        productProfile: {
          ...pick(selected, [
            'id',
            'name',
            'image',
            'itemNo',
            'supplierName',
            'factoryName'
          ])
        },
        inspectionSubPOItems: EMPTY_SUB_PO_ITEM,
        suppliers: (get(selected, 'productSupplierMaps', []) || [])
          .map(({ supplier }) => supplier)
          .filter((value) => !!value),
        inspectionAQL: {
          ...defaultAQL
        },
        factories: (get(selected, 'productFactoryMaps', []) || [])
          .map(({ factory }) => factory)
          .filter((value) => !!value)
      };
    })
  ];
};
